/** @jsx jsx */
import { Button } from '@datacamp/waffles/button';
import { ChevronUp } from '@datacamp/waffles/icon';
import { Menu } from '@datacamp/waffles/menu';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import last from 'lodash/last';
import map from 'lodash/map';
import React from 'react';

import hcKeyListener from '../HighOrderComponents/hcKeyListener';

const menuTriggerStyle = {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderRight: 0,
  ':after': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
} as const;

const submitButtonStyle = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  ':before': {
    content: "''",
    display: 'block',
    position: 'absolute',
    width: 2,
    top: -2,
    bottom: -2,
    left: -2,
    background: tokens.colors.greenDark,
  },
  ':after': {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
} as const;

type Props = {
  isActive: boolean;
  loading: boolean;
  markdown?: {
    activeTitle?: string;
    titles?: string[];
  };
  onSubmit: (...args: any[]) => any;
  onUpdateActivateTitle: (...args: any[]) => any;
};

const handleKeyDown = (e: KeyboardEvent, props: Props) => {
  if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'Enter') {
    if (!props.isActive) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    props.onSubmit();
  }
};

class CustomSubmitButton extends React.Component<Props> {
  onSubmit() {
    this.props.onSubmit({
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      format: last(this.props.markdown.activeTitle.split(' ')),
    });
  }

  updateActiveTitle(title: any) {
    this.props.onUpdateActivateTitle({ activeTitle: title });
  }

  render() {
    const {
      loading,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'activeTitle' does not exist on type '{ a... Remove this comment to see the full error message
      markdown: { activeTitle, titles },
    } = this.props;
    return (
      <div
        css={{
          display: 'flex',
        }}
      >
        <Menu
          trigger={
            <Button
              variant="primary"
              aria-label="Open knit menu"
              icon={<ChevronUp />}
              data-cy="markdown-dropdown-button"
              isLoading={loading}
              css={menuTriggerStyle}
            />
          }
          placement="topRight"
        >
          <Menu.Category noDivider>
            {map(titles, (title, index) => {
              return (
                <Menu.Item
                  key={title}
                  label={title}
                  data-cy={`markdown-dropdown-select-${index}`}
                  onClick={() => this.updateActiveTitle(title)}
                />
              );
            })}
          </Menu.Category>
        </Menu>
        <Button
          variant="primary"
          data-testid="markdown-submit-button"
          data-cy="markdown-submit-button"
          isLoading={loading}
          onClick={() => this.onSubmit()}
          css={submitButtonStyle}
        >
          {activeTitle}
        </Button>
      </div>
    );
  }
}

export default hcKeyListener(handleKeyDown)(CustomSubmitButton);
